<div class="merchandiseDetail-container">
  <div class="row">
    <div class="col-12 col-lg-5">
      <app-skeleton className="w-100% r-12 c-bgt" extraClassName="img-skeleton"></app-skeleton>
    </div>
    <div class="col-12 col-lg-7">
      <div class="details-card d-flex flex-column mt-3 mt-lg-0">
        <!-- Title -->
        <app-skeleton className="h-24 w-50% r-4 c-post" extraClassName="mb-2"></app-skeleton>
        <!-- Description -->
        <app-skeleton className="h-14 w-90% r-4 c-post" extraClassName="mb-2"></app-skeleton>
        <app-skeleton className="h-14 w-60% r-4 c-post" extraClassName="mb-3"></app-skeleton>
        <!-- Price -->
        <app-skeleton className="h-12 w-80 r-4 c-post" extraClassName="mb-1"></app-skeleton>
        <app-skeleton className="h-22 w-100 r-4 c-post" extraClassName="mb-3"></app-skeleton>
        <!-- Buy button -->
        <app-skeleton className="w-100% md:w-200 h-44 r-24 c-post"></app-skeleton>
      </div>
    </div>
  </div>
</div>
